import { render, staticRenderFns } from "./QuoteBlock.vue?vue&type=template&id=44b9caf4&"
import script from "./QuoteBlock.vue?vue&type=script&lang=js&"
export * from "./QuoteBlock.vue?vue&type=script&lang=js&"
import style0 from "./QuoteBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports